<template>
  <v-container class="py-0">
    <v-row>
      <v-col>
        <div class="display-1 font-weight-normal mb-6 text-center">
          Vamos preencher as informações necessárias para a etapa de Base Incremental
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-checkbox v-model="checkboxRoaOuAis">
          <template v-slot:label>
            <div style="color: #6e6e6e">Há necessidade de arquivo DE-PARA para projetos entre ROA e AIS</div>
          </template>
        </v-checkbox>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-checkbox v-model="checkboxDepreciarDia" class="mt-0">
          <template v-slot:label>
            <div style="color: #6e6e6e">
              Considerar o dia para depreciar
              <br />
              <b>
                (Exemplo: Imobilizado dia 1° toma carga no mesmo mês. Imobilizado no dia 30 toma carga somente no mês seguinte)
              </b>
            </div>
          </template>
        </v-checkbox>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-checkbox v-model="checkboxDepreciarMes" class="mt-0">
          <template v-slot:label>
            <div style="color: #6e6e6e">Considerar o próprio mês para depreciar</div>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {},

    data: () => ({
      checkboxRoaOuAis: false,
      checkboxDepreciarMes: false,
      checkboxDepreciarDia: false
    }),

    methods: {
      exportData() {
        return {
          checkboxRoaOuAis: this.checkboxRoaOuAis == false ? 0 : 1,
          checkboxDepreciarMes: this.checkboxDepreciarMes == false ? 0 : 1,
          checkboxDepreciarDia: this.checkboxDepreciarDia == false ? 0 : 1
        };
      }
    }
  };
</script>
